<template lang="pug">
	.display-objects-tree
		hr
		.screen
			span Scene:
			select.custom-select.custom-select-sm(v-on:change="Settings.setSettingValue(setting.codename, getLocaleByLanguage($event.target.value))")
				option(v-for="screen in screens" :selected="selectedScreenCodename === screen.codename" :value="screen.codename") {{screen.codename}}
		.modes
			span Scene interactivity:
			i.mode.first.fa.fa-mouse-pointer(:class="{active: modes['select-by-click']}" v-on:click="toggleMode('select-by-click')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Select objects by click'}")
			i.mode.fa.fa-arrows-alt(:class="{active: modes['move-by-drag']}" v-on:click="toggleMode('move-by-drag')" v-b-tooltip.hover="{delay: { show: 500, hide: 100 }, title: 'Move objects by drag'}")
		.tree-holder
			.tree(:class=`{
					'sorting': !!dragProcess,
					'cloning': dragProcess && dragProcess.ctrlKey,
					'focus': isFocus
				}` v-on:mousedown="isFocus = true" v-pseudo-modal-name="'display-objects-tree'")
				.tree-line(v-for="(displayObject, index) in treeList" :class=`{
						'hidden': displayObject.options.dashboardVisibilityParent === false || displayObject.options.dashboardVisibility === false,
						'hit': hitDisplayObjectCodename === displayObject.codename,
						'selected': DisplayObject.SelectedDisplayObject && DisplayObject.SelectedDisplayObject.codename === displayObject.codename,
						'dragged': displayObject._dragged,
						'cloning': displayObject._dragged && dragProcess && dragProcess.ctrlKey,
						'put-in': dragProcess && dragProcess.targetDisplayObjectIndex === index && dragProcess.targetPosition === 'inside'
					}` v-on:mouseover="highlightDisplayObject(displayObject.codename)" v-on:mouseout="unhighlightDisplayObject(displayObject.codename)")
					DisplayObjectsTreeLine(
						:displayObject="displayObject"
						:toggleDashboardVisibility="toggleDashboardVisibility"
						:toggleDashboardExpanded="toggleDashboardExpanded"
						:selectDisplayObject="selectDisplayObject"
						:startDisplayObjectsDragging="startDisplayObjectsDragging"
					)
			.drag-tree(:class=`{
					'sorting': !!dragProcess,
					'cloning': dragProcess && dragProcess.ctrlKey
				}`)(v-if="dragProcess && draggedTreeList" :style="{top: `${dragProcess.draggedStartPosition + dragProcess.draggedEndMousePosition - dragProcess.draggedStartMousePosition}px`}")
				.tree-line(v-for="displayObject in draggedTreeList" class="dragged-over")
					DisplayObjectsTreeLine(:displayObject="displayObject")
			.drag-place(v-if="dragProcess && draggedTreeList && (dragProcess.targetPosition === 'top' || dragProcess.targetPosition === 'bottom')" :style="{top: `${dragProcess.targetLinePosition}px`}")
		.add-new-display-object
			DropdownDisplayObjectTypeImage(v-on:select="createDisplayObjectTypeImage($event.assetCodename)")
			DropdownDisplayObjectTypeText(v-on:select="createDisplayObjectTypeText($event.localizationCodename)")
			.add-group(v-on:click="createDisplayObjectTypeGroup()")
				.title Add group
				i.fa.fa-folder
</template>

<script>

	import Screen 							from './../../mixins/screen'

	import { DisplayObject }				from './../../services/DisplayObject'

	import DisplayObjectsTreeLine 			from './DisplayObjectsTreeLine'

	import DropdownDisplayObjectTypeImage 	from './../Controls/DropdownDisplayObjectTypeImage'
	import DropdownDisplayObjectTypeText 	from './../Controls/DropdownDisplayObjectTypeText'

	export default {
		name: 'DisplayObjectsTree',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Version Changed",
				"Selected Display Object Changed",
				"Selected Display Object Cleaned",
				"Selected Version Display Object Added",
				"Selected Version Display Object Deleted",
				"Display Object Hierarchy Changed",
				"Settings Tab Changed:display-objects"
			],
			events: {
				"Settings Tab Changed": function(tabName) {

					if (tabName === 'display-objects') {

						//Без таймаута компонент не успевает срендериться и this.selectedScreenCodename === null;
						setTimeout(() => {

							Broadcast.call("Send To iFrame", [{
								SceneEditor: true,
								SceneEditorScreen: this.selectedScreenCodename,
								SceneEditorModes: this.modes,
								DisplayObjectPropertiesByCodename: Metadata.DisplayObjectPropertiesByCodename
							}]);

						}, 200);

					} else if (this.settingsTabName === 'display-objects') {

						DisplayObject.selectDisplayObject(null);

						Broadcast.call("Send To iFrame", [{
							SceneEditor: false
						}]);

					}

					this.settingsTabName = tabName

				},
				"Selected Version Display Object Added": function(displayObject) {

					if (displayObject['screen_codename'] === this.selectedScreenCodename) {

						Broadcast.call("Send To iFrame", [{
							DisplayObjectCreated: {
								screenCodename: displayObject['screen_codename'],
								displayObject: displayObject
							}
						}]);

					}

				},
				"Selected Version Display Object Deleted": function(displayObject) {

					if (displayObject['screen_codename'] === this.selectedScreenCodename) {

						Broadcast.call("Send To iFrame", [{
							DisplayObjectDeleted: {
								screenCodename: displayObject['screen_codename'],
								displayObjectCodename: displayObject.codename
							}
						}]);

					}

				},
				"Display Object Hierarchy Changed": function(displayObject) {

					if (displayObject['screen_codename'] === this.selectedScreenCodename) {

						Broadcast.call("Send To iFrame", [{
							DisplayObjectHierarchy: {
								screenCodename: displayObject['screen_codename'],
								displayObjectCodename: displayObject.codename,
								parent: displayObject.parent,
								priority: displayObject.priority
							}
						}]);

					}

				},
				"IFrame Data:AppScreensCreated": function() {

					Broadcast.call("Send To iFrame", [{
						SceneEditor: Layout.settingsTabName === 'display-objects',
						SceneEditorScreen: this.selectedScreenCodename,
						SceneEditorModes: this.modes,
						DisplayObjectPropertiesByCodename: Metadata.DisplayObjectPropertiesByCodename
					}]);

				},
				"IFrame Data:HitDisplayObject": function(displayObjectCodename) {

					this.highlightDisplayObject(displayObjectCodename, false);

				},
				"IFrame Data:SelectDisplayObject": function(displayObjectCodename) {

					this.selectDisplayObject(displayObjectCodename, false, false);

				},
				"IFrame Data:DeleteDisplayObject": function(data) {

					this.deleteDisplayObject(data, data.displayObjectCodename);

				},
				"Pseudo Modal Process Hide": function(els) {

					if (!_.includes(els, 'display-objects-tree') && this.isFocus) this.isFocus = false;

				}
			}
		},
		components: {
			DisplayObjectsTreeLine,
			DropdownDisplayObjectTypeImage,
			DropdownDisplayObjectTypeText
		},
		data() {

			this.settingsTabName = '';

			this.screens = [];

			this.treeList = [];
			this.draggedTreeList = [];

			return {
				showed: true,
				modes: {
					'select-by-click': true,
					'move-by-drag': true
				},
				treeLineHeight: 30,
				isFocus: false,
				selectedScreenCodename: '',
				hitDisplayObjectCodename: '',

				dragProcess: null

			};

		},
		mounted() {

			window.addEventListener("mouseup", () => {

				if (this.dragProcess) this.stopDisplayObjectsDragging();

			});

			window.addEventListener("mousemove", e => {

				if (this.dragProcess) this.processDisplayObjectsDragging(e);

			});

			window.addEventListener("keydown", e => {

				if (_.includes(['end-cards', 'playables', 'banners', 'marker'], Layout.page) && Layout.asideOpened && Layout.settingsTabName === 'display-objects') {

					if (e.keyCode === 46 && e.target.tagName !== 'INPUT') this.deleteDisplayObject(e);

					if (e.keyCode === 17) {

						if (this.dragProcess) {

							this.dragProcess.ctrlKey = true;

							this.update();

						}

					}

				}

			});

			window.addEventListener("keyup", e => {

				if (_.includes(['end-cards', 'playables', 'banners', 'marker'], Layout.page) && Layout.asideOpened && Layout.settingsTabName === 'display-objects' && this.isFocus) {

					if (e.keyCode === 17) {

						if (this.dragProcess) {

							this.dragProcess.ctrlKey = false;

							this.update();

						}

					} else if (e.keyCode === 37) {

						this.changeDisplayObjectNesting('left');

					} else if (e.keyCode === 39) {

						this.changeDisplayObjectNesting('right');

					}

				}

			});

		},
		methods: {
			collectData() {

				if (!Version.SelectedVersion) return;

				let versionScreens = DisplayScreen.getVersionScreens(Version.SelectedVersion);

				this.screens = _.sortBy(_.values(versionScreens), 'priority');

				if ((!this.selectedScreenCodename || !versionScreens[this.selectedScreenCodename]) && this.screens[0]) this.selectedScreenCodename = this.screens[0].codename;

				this.treeList = DisplayObject.getVersionDisplayObjectsTreeList(Version.SelectedVersion, this.selectedScreenCodename);

			},
			toggleMode(modeCodename) {

				this.modes[modeCodename] = !this.modes[modeCodename];

				Broadcast.call("Send To iFrame", [{
					SceneEditorModes: this.modes
				}]);

			},
			highlightDisplayObject(displayObjectCodename, sendToIFrame = true) {

				this.hitDisplayObjectCodename = displayObjectCodename;

				//Отправляется 2 раза подряд (возможно из-за изменения css классов по наведению) - нужно исключить это через таймаут
				clearTimeout(this.HitDisplayObjectTimeout);
				this.HitDisplayObjectTimeout = setTimeout(() => {

					if (sendToIFrame) Broadcast.call("Send To iFrame", [{HitDisplayObject: [this.selectedScreenCodename, displayObjectCodename]}]);

				}, 50);

			},
			unhighlightDisplayObject(displayObjectCodename, sendToIFrame = true) {

				if (this.hitDisplayObjectCodename === displayObjectCodename) this.hitDisplayObjectCodename = '';

				//Отправляется 2 раза подряд (возможно из-за изменения css классов по наведению) - нужно исключить это через таймаут
				clearTimeout(this.HitDisplayObjectTimeout);
				this.HitDisplayObjectTimeout = setTimeout(() => {

					if (sendToIFrame) Broadcast.call("Send To iFrame", [{HitDisplayObject: [this.selectedScreenCodename, '']}]);

				}, 50);

			},
			toggleDashboardVisibility(displayObject) {

				displayObject.options.dashboardVisibility = displayObject.options.dashboardVisibility === false;

				DisplayObject.forEachAllChilds(displayObject, child => {

					if (!child.options.dashboardVisibilityParents) child.options.dashboardVisibilityParents = {};

					if (displayObject.options.dashboardVisibility === false) child.options.dashboardVisibilityParents[displayObject.codename] = false;
					else delete child.options.dashboardVisibilityParents[displayObject.codename];

					child.options.dashboardVisibilityParent = _.find(child.options.dashboardVisibilityParents, v => v === false);

				});

				Broadcast.call("Send To iFrame", [{DisplayObjectVisibility: [this.selectedScreenCodename, displayObject.codename, displayObject.options.dashboardVisibility !== false]}]);

				this.update();

			},
			toggleDashboardExpanded(displayObject) {

				displayObject.options.dashboardExpanded = displayObject.options.dashboardExpanded === false;

				this.update();

			},
			selectDisplayObject(displayObjectCodename, sendToIFrame = true, toggle = true) {

				let versionDisplayObjects = DisplayObject.getVersionDisplayObjects(Version.SelectedVersion)[this.selectedScreenCodename];

				if (toggle && DisplayObject.SelectedDisplayObject?.codename === displayObjectCodename) DisplayObject.selectDisplayObject(null);
				else DisplayObject.selectDisplayObject(versionDisplayObjects[displayObjectCodename]);

				if (sendToIFrame) Broadcast.call("Send To iFrame", [{SelectDisplayObject: [this.selectedScreenCodename, displayObjectCodename]}]);

			},
			startDisplayObjectsDragging(displayObject, draggedStartMousePosition, e) {

				this.dragProcess = {
					draggedDisplayObjectCodename: displayObject.codename,
					draggedStartPosition: 0,
					draggedStartMousePosition: draggedStartMousePosition,
					draggedEndMousePosition: 0,

					targetDisplayObjectIndex: 0,
					targetDisplayObjectCodename: '',
					targetPosition: '',
					targetLinePosition: 0
				};

				this.draggedTreeList = DisplayObject.extractTreeToList([displayObject], [], displayObject._offset);

				_.each(this.draggedTreeList, displayObject => displayObject._dragged = true);

				this.dragProcess.draggedStartPosition = this.treeLineHeight * _.findIndex(this.treeList, displayObject => displayObject.codename === this.dragProcess.draggedDisplayObjectCodename);

				//this.dragProcess.draggedStartMousePosition = e.clientY;

				this.processDisplayObjectsDragging(e);

			},
			processDisplayObjectsDragging(e) {

				this.dragProcess.draggedEndMousePosition = e.clientY;

				if (this.dragProcess.draggedStartPosition + this.dragProcess.draggedEndMousePosition - this.dragProcess.draggedStartMousePosition < -this.treeLineHeight * 0.5) this.dragProcess.draggedEndMousePosition = -this.treeLineHeight * 0.5 + this.dragProcess.draggedStartMousePosition - this.dragProcess.draggedStartPosition;
				if (this.dragProcess.draggedStartPosition + this.dragProcess.draggedEndMousePosition - this.dragProcess.draggedStartMousePosition > this.treeList.length * this.treeLineHeight - this.treeLineHeight * 0.5) this.dragProcess.draggedEndMousePosition = this.treeList.length * this.treeLineHeight - this.treeLineHeight * 0.5 + this.dragProcess.draggedStartMousePosition - this.dragProcess.draggedStartPosition;

				let targetLinePosition = this.dragProcess.draggedStartPosition + this.dragProcess.draggedEndMousePosition - this.dragProcess.draggedStartMousePosition;

				let overIndex = Math.round(targetLinePosition / this.treeLineHeight);

				if (overIndex < 0) overIndex = 0;
				if (overIndex > this.treeList.length - 1) overIndex = this.treeList.length - 1;

				let overDisplayObject = this.treeList[overIndex];
				let overDisplayObjectCodename = this.treeList[overIndex].codename;

				let placeModifier = 'inside';

				//Если навели на контейнер - вероятность вставки внутрь должа быть больше
				if (overDisplayObject.childs) {

					if (targetLinePosition - overIndex * this.treeLineHeight < -(this.treeLineHeight / 2) * 0.6) placeModifier = 'top';
					else if (targetLinePosition - overIndex * this.treeLineHeight > (this.treeLineHeight / 2) * 0.6) placeModifier = 'bottom';

				}

				//Если навели на НЕ контейнер - вероятность вставки внутрь должа быть меньше
				else {

					if (targetLinePosition - overIndex * this.treeLineHeight < -(this.treeLineHeight / 2) * 0.15) placeModifier = 'top';
					else if (targetLinePosition - overIndex * this.treeLineHeight > (this.treeLineHeight / 2) * 0.15) placeModifier = 'bottom';

				}

				//Если навели на элемент содержащий дочерние элементы и тип вставки bottom - нужно заменить цель на первый дочерний элемент а тип вставки top - иначе вставляет не туда куда ожидает пользователь
				if (overDisplayObject.childs && placeModifier === 'bottom') {

					overIndex++;
					overDisplayObject = overDisplayObject.childs[0];
					overDisplayObjectCodename = overDisplayObject.codename;
					placeModifier = 'top';

				}

				//Если навели на один из перемещаемых объектов - сбрасываем позицию вставки - нельзя вставлять в те объекты, которые перемещаем
				if (_.find(this.draggedTreeList, displayObject => displayObject.codename === overDisplayObjectCodename)) placeModifier = '';

				//Если навели на объект у которого нет родителя (рутовый контейнер) - разрешается вставлять только в внутрь (inside)
				if (!overDisplayObject.parent && placeModifier !== 'inside') placeModifier = '';

				this.dragProcess.targetDisplayObjectIndex = overIndex;
				this.dragProcess.targetDisplayObjectCodename = overDisplayObjectCodename;
				this.dragProcess.targetPosition = placeModifier;

				this.dragProcess.targetLinePosition = (overIndex + (placeModifier === 'top' ? 0 : 1)) * this.treeLineHeight;

			},
			stopDisplayObjectsDragging() {

				console.log(this.dragProcess.draggedDisplayObjectCodename, '>>', this.dragProcess.targetDisplayObjectCodename, '>>', this.dragProcess.targetPosition);

				if (this.dragProcess.targetPosition) {

					if (this.dragProcess.ctrlKey) {

						Server.sendToServer({
							CloneDisplayObject: {
								versionId: Version.SelectedVersion.id,
								screenCodename: this.selectedScreenCodename,
								displayObjectCodename: this.dragProcess.draggedDisplayObjectCodename,
								targetDisplayObjectCodename: this.dragProcess.targetDisplayObjectCodename,
								targetPosition: this.dragProcess.targetPosition
							}
						});

					} else {

						Server.sendToServer({
							MoveDisplayObject: {
								versionId: Version.SelectedVersion.id,
								screenCodename: this.selectedScreenCodename,
								displayObjectCodename: this.dragProcess.draggedDisplayObjectCodename,
								targetDisplayObjectCodename: this.dragProcess.targetDisplayObjectCodename,
								targetPosition: this.dragProcess.targetPosition
							}
						});

					}

				}

				this.dragProcess = null;

				_.each(this.draggedTreeList, displayObject => delete displayObject._dragged);

			},
			createDisplayObjectTypeImage(assetCodename) {

				Server.sendToServer({
					CreateDisplayObject: {
						versionId: Version.SelectedVersion.id,
						screenCodename: this.selectedScreenCodename,
						proposedDisplayObjectCodename: assetCodename.split('.')[0],
						displayObjectType: 'sprite',
						displayObjectProps: {
							image: assetCodename
						},
						targetDisplayObjectCodename: DisplayObject.SelectedDisplayObject?.codename
					}
				});

			},
			createDisplayObjectTypeText(localizationCodename) {

				Server.sendToServer({
					CreateDisplayObject: {
						versionId: Version.SelectedVersion.id,
						screenCodename: this.selectedScreenCodename,
						proposedDisplayObjectCodename: localizationCodename.split('.')[0],
						displayObjectType: 'text',
						displayObjectProps: {
							text: localizationCodename
						},
						targetDisplayObjectCodename: DisplayObject.SelectedDisplayObject?.codename
					}
				});

			},
			createDisplayObjectTypeGroup() {

				Server.sendToServer({
					CreateDisplayObject: {
						versionId: Version.SelectedVersion.id,
						screenCodename: this.selectedScreenCodename,
						proposedDisplayObjectCodename: 'group',
						displayObjectType: 'container',
						displayObjectProps: {},
						targetDisplayObjectCodename: DisplayObject.SelectedDisplayObject?.codename
					}
				});

			},
			deleteDisplayObject(e) {

				if (!DisplayObject.SelectedDisplayObject) return;

				Broadcast.call('Show Confirm', [{
					caption: 'Delete display object',
					message: `Are you sure you want to delete display object "${DisplayObject.SelectedDisplayObject.codename}"? It will delete all child objects as well.`,
					confirmButtonText: '&nbsp;&nbsp;Delete object',
					confirmButtonIcon: 'fa-remove',
					forceConfirm: e.shiftKey,
					confirmCallback: () => {
						Server.sendToSocket({
							DeleteDisplayObject: {
								versionId: Version.SelectedVersion.id,
								screenCodename: this.selectedScreenCodename,
								displayObjectCodename: DisplayObject.SelectedDisplayObject.codename
							}
						});
					}
				}]);

			},
			changeDisplayObjectNesting(direction) {

				if (DisplayObject.SelectedDisplayObject) {

					Server.sendToSocket({
						ChangeDisplayObjectNesting: {
							versionId: Version.SelectedVersion.id,
							screenCodename: this.selectedScreenCodename,
							displayObjectCodename: DisplayObject.SelectedDisplayObject.codename,
							direction: direction
						}
					});

				}

			}
		}

	}
</script>

<style lang="sass">

	.display-objects-tree
		user-select: none

		.screen
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			justify-content: left
			align-items: center
			padding-top: 20px

			select
				margin: 0
				margin-left: 10px

		.modes
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			justify-content: left
			align-items: center
			margin-top: 10px

			.mode
				display: flex
				justify-content: center
				align-items: center
				width: 20px
				height: 20px
				cursor: pointer
				margin: 3px

			.mode.first
				margin-left: 10px

			.mode.active
				color: #20a8d8

		.tree-holder
			margin: 0 -16px
			margin-top: 10px
			position: relative
			border-top: 1px solid #23282c

		.tree
			margin-top: 1px
			transition: background-color 0.2s

			&.sorting
				cursor: grabbing

		.tree.focus
			background-color: rgba(255,255,255,0.05)

		.drag-tree
			position: absolute
			z-index: 2
			left: 0
			top: 0
			width: calc(100% + 30px)
			//background: #4b545e
			border-top: 1px solid #343a42
			opacity: 0.8

		.drag-place
			position: absolute
			pointer-events: none
			z-index: 1
			left: 0
			top: 0
			width: calc(100% + 30px)
			height: 3px
			background: #272c32
			border-top: 1px solid #272c32
			border-bottom: 1px solid #272c32
			margin-top: -1px

		.add-new-display-object
			display: flex
			align-items: center
			justify-content: left
			flex-direction: row
			white-space: nowrap
			margin-top: 20px

			.dropdown-display-object-type-text
				margin-left: 10px

			.add-group
				border: 1px solid rgba(255, 255, 255, 0.1)
				border-radius: 0.25rem
				background: rgba(255, 255, 255, 0.05) no-repeat
				background-position-x: right 0.75rem
				background-position-y: calc(50% - 1px)
				background-size: 8px 10px
				padding-top: 4px
				padding-bottom: 4px
				padding-right: 0.5rem
				padding-left: 0.5rem
				color: rgba(255, 255, 255, 0.5)
				cursor: pointer
				font-size: 12px
				display: flex
				flex-direction: row-reverse
				justify-content: left
				align-items: center
				margin-left: 10px

				.title
					padding-left: 7px

				i.fa
					margin-top: 2px

			.add-group:hover
				border: 1px solid #20a8d8
				background: rgba(255, 255, 255, 0.1) no-repeat

				.title, i.fa
					color: #20a8d8

</style>
